import React from 'react';
import { Box, Container, Paper } from '@mui/material';
import Skeleton from './Skeleton';

/**
 * ProfileSkeleton - Loading placeholder for profile page
 * 
 * Includes:
 * - Large avatar (120x120)
 * - Name and title
 * - Stats row (3 metrics)
 * - Bio paragraphs
 * - Sections (Especialidades, Experiencia, etc.)
 * 
 * Use this when loading user/therapist profile pages
 * 
 * @version 1.0.0 (Feb 2026)
 */

const ProfileSkeleton = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {/* Header */}
      <Paper elevation={2} sx={{ p: 4, mb: 3, borderRadius: '12px' }}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          {/* Large avatar */}
          <Skeleton
            variant="circular"
            width={120}
            height={120}
            animation="wave"
            sx={{ mb: 2 }}
          />

          {/* Name */}
          <Skeleton
            variant="text"
            width={200}
            height={36}
            animation="wave"
            sx={{ mb: 1 }}
          />

          {/* Title */}
          <Skeleton
            variant="text"
            width={150}
            height={20}
            animation="wave"
          />
        </Box>

        {/* Stats row */}
        <Box display="flex" justifyContent="space-around" mb={3}>
          {[...Array(3)].map((_, i) => (
            <Box key={i} textAlign="center">
              <Skeleton
                variant="text"
                width={60}
                height={32}
                animation="wave"
                sx={{ mb: 0.5, mx: 'auto' }}
              />
              <Skeleton
                variant="text"
                width={80}
                height={16}
                animation="wave"
                sx={{ mx: 'auto' }}
              />
            </Box>
          ))}
        </Box>
      </Paper>

      {/* Bio section */}
      <Paper elevation={2} sx={{ p: 4, mb: 3, borderRadius: '12px' }}>
        <Skeleton
          variant="text"
          width={120}
          height={28}
          animation="wave"
          sx={{ mb: 2 }}
        />
        <Skeleton
          variant="text"
          width="100%"
          height={20}
          animation="wave"
          sx={{ mb: 1 }}
        />
        <Skeleton
          variant="text"
          width="95%"
          height={20}
          animation="wave"
          sx={{ mb: 1 }}
        />
        <Skeleton
          variant="text"
          width="90%"
          height={20}
          animation="wave"
        />
      </Paper>

      {/* Specialties section */}
      <Paper elevation={2} sx={{ p: 4, borderRadius: '12px' }}>
        <Skeleton
          variant="text"
          width={140}
          height={28}
          animation="wave"
          sx={{ mb: 2 }}
        />
        <Box display="flex" gap={1} flexWrap="wrap">
          {[...Array(6)].map((_, i) => (
            <Skeleton
              key={i}
              variant="rectangular"
              width={100}
              height={32}
              animation="wave"
              sx={{ borderRadius: '16px' }}
            />
          ))}
        </Box>
      </Paper>
    </Container>
  );
};

export default ProfileSkeleton;
